import {checkPassport} from '@router/guards/roleGuard'
export default {
    path: '/location',
    component: () => import('@views/LocationView/Index'),
    beforeEnter: checkPassport,
    children: [
      {
        path: 'platform',
        name: 'location.platform',
        component: () => import('@/components/LocationManagement/PlatformLocation')
      },
      {
        path: 'onshore',
        name: 'location.onshore',
        component: () => import('@/components/LocationManagement/OnshoreLocation')
      },
      {
        path: 'assign',
        name: 'location.assign',
        component: () => import('@/components/LocationManagement/AssignLocation')
      },
      {
        path: 'company',
        name: 'location.company',
        component: () => import('@/components/LocationManagement/CompanyLocation')
      },
      {
        path: 'field',
        name: 'location.field',
        component: () => import('@/components/LocationManagement/FieldLocation')
      },
      {
        path: 'dictionary',
        name: 'location.dictionary',
        component: () => import('@/components/LocationManagement/Dictionary')
      },
      {
        path: 'buyer',
        name: 'location.buyer',
        component: () => import('@/components/LocationManagement/BuyerLocation')
      },
      {
        path: 'searchpo',
        name: 'location.searchpo',
        component: () => import('@/components/LocationManagement/SearchPO')
      },
      {
        path: 'modifytype',
        name: 'location.modifytype',
        component: () => import('@/components/ModifyType/ModifyType')
      },
    ]
  }
  